import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Product } from '@mira-avant/mtlibs';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { RouterModule } from '@angular/router';
import { ProductService } from '../../../../services/product.service';
import { ZorroModule } from '../../../../modules/zorro.module';

@Component({
	selector: 'app-products-table',
	standalone: true,
	imports: [CommonModule, NzTableModule, NzButtonModule, NzTypographyModule, RouterModule, ZorroModule],
	templateUrl: './products-table.html',
	styleUrl: './products-table.scss',
})
export class ProductsTable implements OnInit, OnDestroy {
	@Input('mode') public mode: 'select' | 'edit' = 'edit';
	public products: Product[] = [];
	private subscriptions: Subscription = new Subscription();

	constructor(public productService: ProductService) {}

	ngOnInit(): void {
		// Subscribe to products
		this.subscriptions.add(
			this.productService.products$.subscribe(products => {
				this.products = products;
			})
		);

		// Fetch products
		this.productService.getProducts$().catch(error => {
			console.error('Error fetching products:', error);
			this.products = [];
		});
	}

	public async deleteProduct(code: string): Promise<void> {
		try {
			await this.productService.deleteProduct$(code);
		} catch (error) {
			console.error('Error deleting product:', error);
		}
	}

	public selectProduct(product: Product | undefined): void {
		this.productService.selectProduct(product);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
